



import Component from 'vue-class-component'
import DefaultSelect  from '@/components/lib/select/DefaultSelect.vue'
import {SelectModel} from '@/services/types'
import * as utils from '@/services/utils'
import {ISelectUserRoles} from './ISelectUserRoles'

@Component({
    components: {
        DefaultSelect
    }
})
export default class SelectUserRoles extends ISelectUserRoles {
    private componentClass = 'SelectUserRoles'

    private  roleSelectOptions: SelectModel [] = [
        {
            value: 'OWNER',
            text: utils.getUserRole('OWNER')
        },
        {
            value: 'CONTROL',
            text: utils.getUserRole('CONTROL')
        },
        {
            value: 'AUDITOR',
            text: utils.getUserRole('AUDITOR')
        },
        {
            value: 'MANAGER',
            text: utils.getUserRole('MANAGER')
        },
        {
            value: 'READ_ONLY',
            text: utils.getUserRole('READ_ONLY')
        }
    ]
}
